module.exports = __webpack_public_path__ + "static/media/img3.3607e988.jpeg";